import React, { useState } from 'react';
import ProfileOverview from '../../components/client/profile/ProfileOverview';
import ProfileEducation from '../../components/client/profile/ProfileEducation';
import ProfileExperience from '../../components/client/profile/ProfileExperience';
import ProfileFamily from '../../components/client/profile/ProfileFamily';

const ClientProfilePage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'education', label: 'Education' },
    { id: 'experience', label: 'Experience' },
    { id: 'family', label: 'Family' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview': return <ProfileOverview />;
      case 'education': return <ProfileEducation />;
      case 'experience': return <ProfileExperience />;
      case 'family': return <ProfileFamily />;
      default: return <ProfileOverview />;
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">My Profile</h1>
      </div>

      <div className="border-b border-slate-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${activeTab === tab.id
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="mt-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default ClientProfilePage;

